module.exports = __webpack_public_path__ + "static/media/PR4.257daecf.jpg";